import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

import { Body, HeadlineM, Overline } from 'components/Text'
import Colors from 'styles/Colors'
import media from 'styles/media'
import { FluidImage } from 'Types'
import video from 'video/SimulateHeroVid.mp4'

type Props = {
  data: {
    rapidplancreate: FluidImage
  }
}

const SiemensPlugin: React.FC<Props> = ({ data }) => {
  return (
    <Wrapper id="siemens-plugin">
      <TextWrapper>
        <Label bullet>DIGITAL TWIN VALIDATION</Label>
        <Title>
          RapidPlan +<br /> Process <br /> Simulate
        </Title>
        <Paragraph>
          Visualize, prioritize and simulate the task plans to validate robot
          programs through virtual commissioning. Benefit from our long-standing
          partnership with Siemens - use a Realtime plug-in with a seamless
          Process Simulate integration.
        </Paragraph>
        <Lines>////////</Lines>
      </TextWrapper>
      <Software>
        <Video
          // ref={(ref) => setVideoRef(ref)}
          controls={false}
          muted
          autoPlay
          // onCanPlayThrough={() => handleProgress(5)}
          // onLoadStart={() => handleProgress(1)}
          // onLoadedData={() => handleProgress(3)}
          // onLoadedMetadata={() => handleProgress(2)}
          // onCanPlay={() => handleProgress(4)}
          loop
          preload="auto"
        >
          <source src={video} type="video/mp4" />
        </Video>
        {/* <Img fluid={data.rapidplancreate.childImageSharp.fluid} /> */}
      </Software>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 54.5vw;
  min-height: 715px;
  position: relative;
  padding-top: 96px;
  ${media.tabletLandscape} {
    padding-top: 0;
  }
  ${media.tablet} {
    height: 118.5vw;
    min-height: 1020px;
  }
  ${media.mobile} {
    height: 159.2vw;
    min-height: 790px;
  }
  @media screen and (max-width: 300px) {
    min-height: 1000px;
  }
`
const TextWrapper = styled.div`
  width: 64.3vw;
  height: 100%;
  background: ${Colors.neptune};
  padding: 13.1vw 0 0 12.9vw;
  ${media.tabletLandscape} {
    padding-left: 72px;
  }
  ${media.tablet} {
    width: 100%;
    padding: 81.5vw 0 0 48px;
  }
  ${media.mobile} {
    padding: 102.1vw 0 0 12px;
  }
`
const Label = styled(Overline)`
  color: ${Colors.whiteSmoke};
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.whiteSmoke};
  }
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`
const Title = styled(HeadlineM)`
  color: ${Colors.whiteSmoke};
  font-size: 3.2vw;
  margin-bottom: 1vw;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
  }
`
const Paragraph = styled(Body)`
  width: 25.6vw;
  right: 42.9vw;
  top: 12.4vw;
  color: ${Colors.whiteSmoke};
  ${media.tablet} {
    width: calc(100% - 96px);
    left: 48px;
    top: 9.4vw;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    left: 12px;
    top: 25.6vw;
  }
`
const Software = styled.div`
  position: absolute;
  width: 43.6vw;
  top: 15.6vw;
  right: 150px;
  ${media.tablet} {
    top: 12.5vw;
    left: 48px;
    width: calc(100% - 96px);
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    left: 12px;
    top: 25.6vw;
  }
`
const Video = styled.video`
  position: absolute;
  outline: none;
  border: none;
  margin: 0;
  width: 46.1vw;
  top: 0.9vw;
  left: 0.4vw;
  z-index: 1;
  ${media.tabletLandscape} {
    width: 100%;
  }
`
const Lines = styled(HeadlineM)`
  color: ${Colors.whiteSmoke};
  position: absolute;
  top: 46.9vw;
  left: -7px;
  transform: rotate(-90deg);
  ${media.tabletLandscape} {
    font-size: 36px;
  }
  ${media.tablet} {
    top: 88.7vw;
    left: auto;
    right: 14px;
  }
  ${media.mobile} {
    font-size: 24px;
    right: -10px;
    top: auto;
    bottom: 48px;
    display: none;
  }
  @media screen and (max-width: 414px) {
    // top: 304vw;
    // display: block;
  }
  @media screen and (max-width: 360px) {
    display: none;
  }
`
export default SiemensPlugin
